module.exports = __webpack_public_path__ + "media/flags/sa-a843d8c7.svg";